import { ICustomProperties, IEventTelemetry } from "@microsoft/applicationinsights-web";

export class GotPowerBiReportsEvent implements IEventTelemetry {
    name: string = "GotPowerBiReportsEvent";
    numberOfReports: number;

    constructor(numberOfReports: number) {
        this.numberOfReports = numberOfReports;
    }

    public getCustomProperties = (): ICustomProperties => {
        return {
            numberOfReports: this.numberOfReports,
        };
    };
}
